module.exports = __webpack_public_path__ + "static/hcpettreats2-a5d98256d87f0558671b8a030d8ddc98.jpg";